import {Icon, Text} from '#component/base';

import {
  appliedCouponsInnerIcon,
  appliedCouponsInnerText,
  appliedCouponsWrapper,
} from './AppliedCodeBox.css';

const AppliedCodeBox = ({
  code,
  handleRemoveCoupon,
}: {
  code: string;
  handleRemoveCoupon: (coupon: string) => void;
}) => {
  return (
    <div className={appliedCouponsWrapper}>
      <Text className={appliedCouponsInnerText}>{code}</Text>
      <picture onClick={() => handleRemoveCoupon(code)} className={appliedCouponsInnerIcon}>
        <Icon name="X" size="xSmall" />
      </picture>
    </div>
  );
};

export default AppliedCodeBox;
